import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { axiosInstance } from '../../../helpers/api_helper';
import { CalculationStatus } from './types';
// import { TravelutionSubscriptionType } from './types';

export const getTravelutionMemberships = createAsyncThunk(
  'getTravelutionMemberships/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(
      '/products/travelution-memberships/orders',
      {
        params
      }
    );

    return response.data.data;
  }
);

export const updateTravelutionMembershipsToPaid = createAsyncThunk(
  'getTravelutionMemberships/updateTravelutionMembershipsToPaid',
  async (
    { id, calculationStatus }: { id: number; calculationStatus: number },
    { rejectWithValue }
  ) => {
    try {
      await axiosInstance.post(
        `/products/travelution-memberships/orders/${id}/confirm?calculationStatus=${calculationStatus}`
      );
      toast.success('Successfully paid Travelution Membership');

      return {
        id,
        calculationStatus
      };
    } catch (error: any) {
      toast.error(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

export const exportHeaders = [
  { label: 'Subscription ID', key: 'subscriptionId' },
  { label: 'User ID', key: 'userId' },
  { label: 'User', key: 'user' },
  { label: 'Subscription Name', key: 'subscriptionName' },
  { label: 'Amount', key: 'amount' },
  { label: 'Payment Address', key: 'paymentAddress' },
  { label: 'Network', key: 'network' },
  { label: 'Order Date', key: 'orderDate' },
  { label: 'Payment Date', key: 'paymentDate' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endedDate' },
  { label: 'Status', key: 'status' }
];

export const statusForTable = (status: number) => {
  switch (status) {
    case 1:
      return 'PENDING';
    case 2:
      return 'PAID';
    case 3:
      return 'CANCELED';
    case 4:
      return 'CANCELED BY USER';

    default:
      break;
  }
};

export const calculationStatusForTable = (status: number) => {
  switch (status) {
    case CalculationStatus.CALCULATE:
      return 'PAID';
    case CalculationStatus.SKIP_WITH_HUB_CREATION:
      return 'PAID WITH HUB NO CALCULATION NO POPV';
    case CalculationStatus.SKIP_WITHOUT_HUB_CREATION:
      return 'PAID NO HUB NO CALCULATION NO POPV';
    case CalculationStatus.SKIP_WITH_HUB_CREATION_ADD_PO_PV:
      return 'PAID WITH HUB NO CALC WITH POPV';
    case CalculationStatus.SKIP_WITHOUT_HUB_CREATION_ADD_PO_PV:
      return 'PAID NO HUB NO CALC WITH POPV';

    case CalculationStatus.SKIP_WITH_HUB_CREATION_ADD_PO:
      return 'PAID WITH HUB NO CALCULATION WITH PO';
    case CalculationStatus.SKIP_WITHOUT_HUB_CREATION_ADD_PO:
      return 'PAID NO HUB NO CALCULATION WITH PO';
    case CalculationStatus.SKIP_WITH_HUB_CREATION_ADD_PV:
      return 'PAID WITH HUB NO CALCULATION WITH PV';
    case CalculationStatus.SKIP_WITHOUT_HUB_CREATION_ADD_PV:
      return 'PAID NO HUB NO CALCULATION WITH PV';
    case CalculationStatus.LP_TRADING_ADD_PO:
      return 'PAID (LP) WITH HUB NO CALCULATION NO POPV';

    default:
      break;
  }
};

export const licenceType = (status: number) => {
  switch (status) {
    case 1:
      return 'ORDER';
    case 2:
      return 'PACKAGE';
    case 3:
      return 'LICENCE';
    case 4:
      return 'COMBO';
    case 7:
      return 'TRAVELUTION SUBSCRIPTION';

    default:
      break;
  }
};

export interface MembershipStateInterface {
  data: any;
  loading: boolean;

  totalCount: number;
  dataForExport: [];
}

const initialState = {
  data: [],
  totalCount: 0,
  loading: false,
  dataForExport: []
} as MembershipStateInterface;

const travelutionMembershipSlice = createSlice({
  name: 'travelutionMembershipSlice',
  initialState,
  reducers: {
    // fill in primary logic here
  },
  extraReducers: (builder) => {
    builder.addCase(getTravelutionMemberships.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getTravelutionMemberships.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.data = payload.orders;
        state.totalCount = payload.count;
      }
    );
    builder.addCase(getTravelutionMemberships.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(updateTravelutionMembershipsToPaid.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      updateTravelutionMembershipsToPaid.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const index = state.data.findIndex((p: any) => p.id === payload.id);
        state.data[index] = {
          ...state.data[index],
          calculationStatus: payload.calculationStatus,
          status: 2
        };
      }
    );
    builder.addCase(updateTravelutionMembershipsToPaid.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default travelutionMembershipSlice.reducer;
